
const setCliente = (context,cliente) => {
	context.commit('SET_CLIENTE', cliente);
}

const setTenant = (context, tenant) => {
	context.commit('SET_TENANT', tenant);
}

export{
	setCliente,
	setTenant
}





// WEBPACK FOOTER //
// ./src/store/cliente/actions.js